import { loadable } from '@change-corgi/core-react/loadable';

import type { AppRoute } from '#src/shared/routes';

import { Loading } from '#src/app/shared/routes';

export const ROUTES: readonly AppRoute[] = [
	{
		id: 'admin-user-impersonate',
		path: '/admin/u/impersonate',
		component: loadable(async () => import(/* webpackChunkName: "pages/admin_user_impersonate" */ './index'), {
			exportName: 'AdminUserImpersonate',
			fallback: Loading,
		}),
		restrictedAccess: {
			authOnly: true,
			role: ['support', 'campaigns'],
		},
		priority: 10,
		frame: true,
		ssr: {
			enabled: false,
			seo: false,
		},
	},
];
